/*
 * DefaultCheckBox.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 04 2023 mys Company
 */

import { debounce } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { isNullOrEmpty } from '../../utilities/mysUtilities'

const DefaultCheckBox = ({ name, caption, placeHolder, type = 'text', captionClassName, inputMode = 'text', inputClassName, inputValue, errorMessage, className, minLength, maxLength, onChange, onBlur, onFocus }) => {
    // MARK: VARIABLE

    let [focused, setFocused] = useState(false)
    let [maxShowError, setMaxShowError] = useState(false)
    let [minShowError, setMinShowError] = useState(false)
    let [showError, setShowError] = useState(false)
    let [currentValue, setCurrentValue] = useState(inputValue)

    // MARK: METHOD

    const handleFocus = () => {
        setFocused(isNullOrEmpty(currentValue) ? true : false)
        if (onFocus) onFocus()
    }
    const handleChange = (e) => {
        setShowError(false)
        if (onChange) onChange(e.target.checked)
    }
    const handleBlur = () => {}

    useEffect(() => {
        setFocused(isNullOrEmpty(currentValue) ? true : false)
    })

    return (
        <>
            <div className={` ${className ?? ''}`}>
                <input type="checkbox" id={name} className={`inline-block relative mt-1  outline-none ${inputClassName ?? ''}`} checked={inputValue} placeholder={placeHolder} onChange={handleChange} />
                <label htmlFor={name} className={`inline-block relative text-sm pr-2 select-none ${captionClassName}`}>
                    {caption}
                </label>
            </div>
            <div className={`text-red-500 text-xs ${showError || maxShowError || minShowError ? 'opacity-1' : 'opacity-0'}`}>{errorMessage}</div>
        </>
    )
}

export default DefaultCheckBox
